<tim-navbar *ngIf="authService.loggedIn$"></tim-navbar>
<router-outlet></router-outlet>
